<template>
  <div class="mt-sm-4 border">
    <!-- {{ data }} -->
    <div class="mt-3">
      <h5 class="">
        <b>Данные отправителя:</b> {{ data.sender_name }} /
        {{ data.sender_phone }}
      </h5>
      <h5 class="">
        <b>Меcто отправки:</b> {{ data.shop.location.location.title }} /
        {{ data.shop.location.title }}
      </h5>
      <h3>BTS - оформление заявки</h3>
      <h5 v-if="data.exchange_status_id" class="mb-2 text-info text-bold mt-3">
        Статус: <bts-statuses :id="data.exchange_status_id" />
      </h5>
      <h5 v-if="data.exchange_status_id" class="mb-2 text-info text-bold">
        Штрих-код: <span>{{ data.name }}</span>
      </h5>
      <h5 v-if="data.exchange_status_id" class="mb-2 text-info text-bold">
        ID: <span>{{ data.exchange_id }}</span>
      </h5>
      <ul class="mb-4">
        <template>
          <li
            v-show="r.body"
            v-for="(r, key) in requests"
            :key="key"
            class="mb-3"
          >
            <div v-if="r.body && r.response">
              <div v-if="r.state === 'new'">
                <h5>
                  <span class="text-info">Стоимость услуги:</span>
                  {{ r.response.summaryPrice | spaceBetweenNumber }} UZS
                </h5>
              </div>
              <div v-else-if="r.state === 'sent'">
                <h5>
                  <span class="text-info">Накладная: </span>
                  <a
                    target="_blank"
                    class="btn btn-warning mw"
                    :href="r.response.labelEncode"
                    >Скачать документ</a
                  >
                </h5>
              </div>
            </div>
          </li>
        </template>
      </ul>
      <component
        :region="region"
        :is="state"
        :currentRequest="currentRequest"
        :data="data"
        v-model="setValue"
        :id="data.id"
        @update="update"
      />
    </div>
    <!-- <div v-else>
      <h4 class="mt-3 text-danger">
        Нельзя оформить заявку - нет синхронизации локаций BTS
      </h4>
    </div> -->
  </div>
</template>
<script>
export default {
  methods: {},
  components: {
    new: () => import("./new"),
    done: () => import("./done"),
    sent: () => import("./sent"),
  },
  methods: {
    update() {
      this.$emit("update", true);
    },
  },
  data: () => ({
    regions: [
      {
        id: 18,
        name: "Бектемирский район",
        exchange_id: 190,
      },
      {
        id: 2,
        name: "Яшнабадский район",
        exchange_id: 196,
      },
      {
        id: 19,
        name: "Чиланзарский район",
        exchange_id: 197,
      },
      {
        id: 20,
        name: "Мирзо-Улугбекский район",
        exchange_id: 192,
      },
      {
        id: 21,
        name: "Сергелийский район",
        exchange_id: 193,
      },
      {
        id: 22,
        name: "Шайхантахурский район",
        exchange_id: 198,
      },
      {
        id: 23,
        name: "Алмазарский район",
        exchange_id: 194,
      },
      {
        id: 24,
        name: "Учтепинский район",
        exchange_id: 195,
      },
      {
        id: 25,
        name: "Яккасарайский район",
        exchange_id: 200,
      },
      {
        id: 26,
        name: "Юнусабадский район",
        exchange_id: 199,
      },
      {
        id: 27,
        name: "Андижан",
        exchange_id: 25,
      },
      {
        id: 28,
        name: "Шахрихан",
        exchange_id: 39,
      },
      {
        id: 29,
        name: "Асака",
        exchange_id: 3,
      },
      {
        id: 30,
        name: "Ханабад",
        exchange_id: 26,
      },
      {
        id: 31,
        name: "Аим",
        exchange_id: 0,
      },
      {
        id: 32,
        name: "Кургантепа",
        exchange_id: 38,
      },
      {
        id: 33,
        name: "Карасу",
        exchange_id: 0,
      },
      {
        id: 34,
        name: "Пайтуг",
        exchange_id: 0,
      },
      {
        id: 35,
        name: "Дардак",
        exchange_id: 0,
      },
      {
        id: 36,
        name: "Пахтаабад",
        exchange_id: 35,
      },
      {
        id: 37,
        name: "Боз",
        exchange_id: 30,
      },
      {
        id: 38,
        name: "Султанабад",
        exchange_id: 0,
      },
      {
        id: 39,
        name: "Ходжаабад",
        exchange_id: 36,
      },
      {
        id: 40,
        name: "Мархамат",
        exchange_id: 34,
      },
      {
        id: 41,
        name: "Джалакудук",
        exchange_id: 31,
      },
      {
        id: 42,
        name: "Куйганъяр",
        exchange_id: 0,
      },
      {
        id: 43,
        name: "Булакбаши",
        exchange_id: 29,
      },
      {
        id: 44,
        name: "Акалтын",
        exchange_id: 0,
      },
      {
        id: 45,
        name: "Южный Аламышик",
        exchange_id: 0,
      },
      {
        id: 46,
        name: "Палванташ",
        exchange_id: 0,
      },
      {
        id: 47,
        name: "Балыкчи",
        exchange_id: 28,
      },
      {
        id: 48,
        name: "Бухара",
        exchange_id: 40,
      },
      {
        id: 49,
        name: "Каган",
        exchange_id: 41,
      },
      {
        id: 50,
        name: "Гиждуван",
        exchange_id: 52,
      },
      {
        id: 51,
        name: "Шафиркан",
        exchange_id: 49,
      },
      {
        id: 52,
        name: "Каракуль",
        exchange_id: 50,
      },
      {
        id: 53,
        name: "Алат",
        exchange_id: 46,
      },
      {
        id: 54,
        name: "Галаасия",
        exchange_id: 55,
      },
      {
        id: 55,
        name: "Вабкент",
        exchange_id: 0,
      },
      {
        id: 56,
        name: "Зафарабад",
        exchange_id: 60,
      },
      {
        id: 57,
        name: "Ромитан",
        exchange_id: 48,
      },
      {
        id: 58,
        name: "Газли",
        exchange_id: 0,
      },
      {
        id: 59,
        name: "Караулбазар",
        exchange_id: 51,
      },
      {
        id: 60,
        name: "Жондор",
        exchange_id: 0,
      },
      {
        id: 61,
        name: "Джизак",
        exchange_id: 57,
      },
      {
        id: 62,
        name: "Гагарин",
        exchange_id: 0,
      },
      {
        id: 63,
        name: "Галляарал",
        exchange_id: 55,
      },
      {
        id: 64,
        name: "Пахтакор",
        exchange_id: 63,
      },
      {
        id: 65,
        name: "Даштабад",
        exchange_id: 0,
      },
      {
        id: 66,
        name: "Муйнак",
        exchange_id: 17,
      },
      {
        id: 67,
        name: "Шуманай",
        exchange_id: 23,
      },
      {
        id: 68,
        name: "Бустан",
        exchange_id: 0,
      },
      {
        id: 69,
        name: "Канлыкуль",
        exchange_id: 0,
      },
      {
        id: 70,
        name: "Акмангит",
        exchange_id: 0,
      },
      {
        id: 71,
        name: "Казанкеткен",
        exchange_id: 0,
      },
      {
        id: 72,
        name: "Карши",
        exchange_id: 66,
      },
      {
        id: 73,
        name: "Шахрисабз",
        exchange_id: 72,
      },
      {
        id: 74,
        name: "Касан",
        exchange_id: 74,
      },
      {
        id: 75,
        name: "Китаб",
        exchange_id: 75,
      },
      {
        id: 76,
        name: "Камаши",
        exchange_id: 70,
      },
      {
        id: 77,
        name: "Мубарек",
        exchange_id: 68,
      },
      {
        id: 78,
        name: "Яккабаг",
        exchange_id: 79,
      },
      {
        id: 79,
        name: "Гузар",
        exchange_id: 69,
      },
      {
        id: 80,
        name: "Карашина",
        exchange_id: 0,
      },
      {
        id: 81,
        name: "Чиракчи",
        exchange_id: 71,
      },
      {
        id: 82,
        name: "Эски-Яккабаг",
        exchange_id: 0,
      },
      {
        id: 83,
        name: "Янги-Нишан",
        exchange_id: 0,
      },
      {
        id: 84,
        name: "Муглан",
        exchange_id: 0,
      },
      {
        id: 85,
        name: "Мираки",
        exchange_id: 0,
      },
      {
        id: 86,
        name: "Янги-Миришкор",
        exchange_id: 0,
      },
      {
        id: 87,
        name: "Навои",
        exchange_id: 80,
      },
      {
        id: 88,
        name: "Зарафшан",
        exchange_id: 81,
      },
      {
        id: 89,
        name: "Учкудук",
        exchange_id: 89,
      },
      {
        id: 90,
        name: "Нурата",
        exchange_id: 85,
      },
      {
        id: 91,
        name: "Кармана",
        exchange_id: 82,
      },
      {
        id: 92,
        name: "Янгирабад",
        exchange_id: 0,
      },
      {
        id: 93,
        name: "Кызылтепа",
        exchange_id: 87,
      },
      {
        id: 94,
        name: "Канимех",
        exchange_id: 0,
      },
      {
        id: 95,
        name: "Газган",
        exchange_id: 0,
      },
      {
        id: 96,
        name: "Мурунтау",
        exchange_id: 0,
      },
      {
        id: 97,
        name: "Тинчлик",
        exchange_id: 0,
      },
      {
        id: 98,
        name: "Наманган",
        exchange_id: 90,
      },
      {
        id: 99,
        name: "Чуст",
        exchange_id: 99,
      },
      {
        id: 100,
        name: "Чартак",
        exchange_id: 98,
      },
      {
        id: 101,
        name: "Касансай",
        exchange_id: 92,
      },
      {
        id: 102,
        name: "Учкурган",
        exchange_id: 97,
      },
      {
        id: 103,
        name: "Янгикурган",
        exchange_id: 100,
      },
      {
        id: 104,
        name: "Туракурган",
        exchange_id: 95,
      },
      {
        id: 105,
        name: "Хаккулабад",
        exchange_id: 94,
      },
      {
        id: 106,
        name: "Пап",
        exchange_id: 2,
      },
      {
        id: 107,
        name: "Уйчи",
        exchange_id: 96,
      },
      {
        id: 108,
        name: "Джумашуй",
        exchange_id: 0,
      },
      {
        id: 109,
        name: "Ташбулак",
        exchange_id: 0,
      },
      {
        id: 110,
        name: "Акташ",
        exchange_id: 0,
      },
      {
        id: 111,
        name: "Самарканд",
        exchange_id: 101,
      },
      {
        id: 112,
        name: "Каттакурган",
        exchange_id: 113,
      },
      {
        id: 113,
        name: "Ургут",
        exchange_id: 102,
      },
      {
        id: 114,
        name: "Акташ",
        exchange_id: 109,
      },
      {
        id: 115,
        name: "Джамбай",
        exchange_id: 107,
      },
      {
        id: 116,
        name: "Булунгур",
        exchange_id: 106,
      },
      {
        id: 117,
        name: "Пайшанба",
        exchange_id: 0,
      },
      {
        id: 118,
        name: "Джума",
        exchange_id: 0,
      },
      {
        id: 119,
        name: "Челек",
        exchange_id: 114,
      },
      {
        id: 120,
        name: "Тайлак",
        exchange_id: 110,
      },
      {
        id: 121,
        name: "Гюлабад",
        exchange_id: 0,
      },
      {
        id: 122,
        name: "Чархин",
        exchange_id: 0,
      },
      {
        id: 123,
        name: "Лаиш",
        exchange_id: 115,
      },
      {
        id: 124,
        name: "Иштыхан",
        exchange_id: 116,
      },
      {
        id: 125,
        name: "Зиадин",
        exchange_id: 0,
      },
      {
        id: 126,
        name: "Пайарык",
        exchange_id: 114,
      },
      {
        id: 127,
        name: "Нурабад",
        exchange_id: 0,
      },
      {
        id: 128,
        name: "Кошрабад",
        exchange_id: 108,
      },
      {
        id: 129,
        name: "Митан",
        exchange_id: 0,
      },
      {
        id: 130,
        name: "Сув-Ховузи",
        exchange_id: 0,
      },
      {
        id: 131,
        name: "Термез",
        exchange_id: 117,
      },
      {
        id: 132,
        name: "Денау",
        exchange_id: 121,
      },
      {
        id: 133,
        name: "Сариасия",
        exchange_id: 122,
      },
      {
        id: 134,
        name: "Джаркурган",
        exchange_id: 124,
      },
      {
        id: 135,
        name: "Шерабад",
        exchange_id: 129,
      },
      {
        id: 136,
        name: "Байсун",
        exchange_id: 127,
      },
      {
        id: 137,
        name: "Шурчи",
        exchange_id: 128,
      },
      {
        id: 138,
        name: "Ангор",
        exchange_id: 125,
      },
      {
        id: 139,
        name: "Учкызыл",
        exchange_id: 0,
      },
      {
        id: 140,
        name: "Сарых",
        exchange_id: 0,
      },
      {
        id: 141,
        name: "Узун",
        exchange_id: 130,
      },
      {
        id: 142,
        name: "Кумкурган",
        exchange_id: 126,
      },
      {
        id: 143,
        name: "Карлук",
        exchange_id: 0,
      },
      {
        id: 144,
        name: "Шаргунь",
        exchange_id: 0,
      },
      {
        id: 145,
        name: "Бандихон",
        exchange_id: 0,
      },
      {
        id: 146,
        name: "Халкабад",
        exchange_id: 0,
      },
      {
        id: 147,
        name: "Гулистан",
        exchange_id: 131,
      },
      {
        id: 148,
        name: "Янгиер",
        exchange_id: 132,
      },
      {
        id: 149,
        name: "Сырдарья",
        exchange_id: 140,
      },
      {
        id: 150,
        name: "Хаваст",
        exchange_id: 141,
      },
      {
        id: 151,
        name: "Ширин",
        exchange_id: 133,
      },
      {
        id: 152,
        name: "Сардаба",
        exchange_id: 139,
      },
      {
        id: 153,
        name: "Пахтаабад",
        exchange_id: 35,
      },
      {
        id: 154,
        name: "Дехканабад",
        exchange_id: 78,
      },
      {
        id: 155,
        name: "Бахт",
        exchange_id: 0,
      },
      {
        id: 156,
        name: "Баяут",
        exchange_id: 135,
      },
      {
        id: 157,
        name: "Сайхун",
        exchange_id: 138,
      },
      {
        id: 158,
        name: "Навруз",
        exchange_id: 0,
      },
      {
        id: 159,
        name: "Чирчик",
        exchange_id: 145,
      },
      {
        id: 160,
        name: "Ангрен",
        exchange_id: 142,
      },
      {
        id: 161,
        name: "Алмалык",
        exchange_id: 144,
      },
      {
        id: 162,
        name: "Бекабад",
        exchange_id: 143,
      },
      {
        id: 163,
        name: "Янгиюль",
        exchange_id: 158,
      },
      {
        id: 164,
        name: "Паркент",
        exchange_id: 152,
      },
      {
        id: 165,
        name: "Ахангаран",
        exchange_id: 6,
      },
      {
        id: 166,
        name: "Пскент",
        exchange_id: 201,
      },
      {
        id: 167,
        name: "Бука",
        exchange_id: 157,
      },
      {
        id: 168,
        name: "Кибрай",
        exchange_id: 148,
      },
      {
        id: 169,
        name: "Искандар",
        exchange_id: 0,
      },
      {
        id: 170,
        name: "Салар",
        exchange_id: 0,
      },
      {
        id: 171,
        name: "Бектемир",
        exchange_id: 190,
      },
      {
        id: 172,
        name: "Келес",
        exchange_id: 0,
      },
      {
        id: 173,
        name: "Алмазар",
        exchange_id: 0,
      },
      {
        id: 174,
        name: "Чиназ",
        exchange_id: 155,
      },
      {
        id: 175,
        name: "Газалкент",
        exchange_id: 0,
      },
      {
        id: 176,
        name: "Нурафшон",
        exchange_id: 7,
      },
      {
        id: 177,
        name: "Дустабад",
        exchange_id: 0,
      },
      {
        id: 178,
        name: "Красногорск",
        exchange_id: 0,
      },
      {
        id: 179,
        name: "Аккурган",
        exchange_id: 151,
      },
      {
        id: 180,
        name: "Гульбахор",
        exchange_id: 0,
      },
      {
        id: 181,
        name: "Янгиабад",
        exchange_id: 65,
      },
      {
        id: 182,
        name: "Янгибазар",
        exchange_id: 186,
      },
      {
        id: 183,
        name: "Чарвак",
        exchange_id: 0,
      },
      {
        id: 184,
        name: "Бурчмулла",
        exchange_id: 0,
      },
      {
        id: 185,
        name: "Коканд",
        exchange_id: 163,
      },
      {
        id: 186,
        name: "Фергана",
        exchange_id: 160,
      },
      {
        id: 229,
        name: "Риштанский район",
        exchange_id: 171,
      },
      {
        id: 187,
        name: "Маргилан",
        exchange_id: 161,
      },
      {
        id: 188,
        name: "Учкуприк",
        exchange_id: 174,
      },
      {
        id: 189,
        name: "Кува",
        exchange_id: 177,
      },
      {
        id: 190,
        name: "Кувасай",
        exchange_id: 162,
      },
      {
        id: 191,
        name: "Риштан",
        exchange_id: 171,
      },
      {
        id: 192,
        name: "Бешарык",
        exchange_id: 169,
      },
      {
        id: 193,
        name: "Яйпан",
        exchange_id: 0,
      },
      {
        id: 194,
        name: "Ибрат",
        exchange_id: 0,
      },
      {
        id: 195,
        name: "Тинчлик",
        exchange_id: 0,
      },
      {
        id: 196,
        name: "Ташлак",
        exchange_id: 173,
      },
      {
        id: 197,
        name: "Багдад",
        exchange_id: 164,
      },
      {
        id: 198,
        name: "Раван",
        exchange_id: 0,
      },
      {
        id: 199,
        name: "Дангара",
        exchange_id: 166,
      },
      {
        id: 200,
        name: "Язъяван",
        exchange_id: 167,
      },
      {
        id: 201,
        name: "Шорсу",
        exchange_id: 0,
      },
      {
        id: 202,
        name: "Ургенч",
        exchange_id: 179,
      },
      {
        id: 203,
        name: "Хива",
        exchange_id: 10,
      },
      {
        id: 204,
        name: "Ханка",
        exchange_id: 183,
      },
      {
        id: 205,
        name: "Гурлен",
        exchange_id: 189,
      },
      {
        id: 206,
        name: "Шават",
        exchange_id: 188,
      },
      {
        id: 207,
        name: "Хазарасп",
        exchange_id: 187,
      },
      {
        id: 208,
        name: "Янгибазар",
        exchange_id: 186,
      },
      {
        id: 209,
        name: "Заамин",
        exchange_id: 61,
      },
      {
        id: 210,
        name: "Дустлик",
        exchange_id: 56,
      },
      {
        id: 211,
        name: "Янгикишлак",
        exchange_id: 0,
      },
      {
        id: 212,
        name: "Баландчакир",
        exchange_id: 0,
      },
      {
        id: 213,
        name: "Учтепа",
        exchange_id: 0,
      },
      {
        id: 214,
        name: "Усмат",
        exchange_id: 0,
      },
      {
        id: 215,
        name: "Голиблар",
        exchange_id: 0,
      },
      {
        id: 216,
        name: "Зафарабад",
        exchange_id: 60,
      },
      {
        id: 217,
        name: "Марджанбулак",
        exchange_id: 0,
      },
      {
        id: 218,
        name: "Нукус",
        exchange_id: 8,
      },
      {
        id: 219,
        name: "Ходжейли",
        exchange_id: 21,
      },
      {
        id: 220,
        name: "Кунград",
        exchange_id: 16,
      },
      {
        id: 221,
        name: "Тахиаташ",
        exchange_id: 9,
      },
      {
        id: 222,
        name: "Беруни",
        exchange_id: 12,
      },
      {
        id: 223,
        name: "Турткуль",
        exchange_id: 20,
      },
      {
        id: 224,
        name: "Чимбай",
        exchange_id: 22,
      },
      {
        id: 225,
        name: "Кегейли",
        exchange_id: 15,
      },
      {
        id: 226,
        name: "Мангит",
        exchange_id: 11,
      },
      {
        id: 227,
        name: "Караузяк",
        exchange_id: 14,
      },
      {
        id: 228,
        name: "Тахтакупыр",
        exchange_id: 19,
      },
    ],
  }),
  props: ["value", "data"],
  computed: {
    region() {
      return this.regions.find(
        (item) => item.id === this.data.shop.location_id
      );
    },
    requests() {
      return this.data.service_requests.filter(
        (item) => item && item.service && item.service.code === "bts"
      );
    },
    currentRequest() {
      try {
        return this.requests[0];
      } catch (error) {}

      return null;
    },
    state() {
      return this.currentRequest && this.currentRequest["state"]
        ? this.currentRequest["state"]
        : "cancel";
    },
    setValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>
 